/* eslint-disable no-nested-ternary */
import React, { useContext } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import Auth from "components/Auth";
import ScrollToTop from "components/ScrollToTop";
import Cart from "containers/Cart";
import Catalog from "containers/Catalog";
import Checkout from "containers/Checkout";
import Search from "containers/Search";
import Product from "containers/Product";
import Partner from "containers/Partner";
import Partners from "containers/Partners";
import Home from "containers/Home";
import Order from "containers/Order";
import Orders from "containers/Orders";
import ErrorPage from "containers/Error";
import NotFound from "containers/Error/components/notFound";
import PurchaseTerms from "components/PurchaseTerms";
import CookiePolicy from "components/CookiePolicy";
import ContactUs from "components/ContactUs";
import Site from "components/Site";
import Faq from "components/Faq/faq";
import ComingSoon from "containers/Home/comingsoon";
import Maintenance from "containers/Home/maintenance";
import RequestPricing from "components/RequestPricing";
import { CartProvider } from "components/CartContext";
import { StoreContext } from "components/StoreContext";
import OldStoreRedirects from "containers/OldStoreRedirects";

import "styles/App.scss";

const App = () => {
  const { config } = useContext(StoreContext);
  return config.features.ComingSoonPage === true ? (
    <ComingSoon />
  ) : config.features.MaintenancePage === true ? (
    <Maintenance />
  ) : (
    <Router>
      <ScrollToTop>
        <Auth config={config}>
          <CartProvider>
            <Site>
              <Switch>
                <Route path="/catalog" component={Catalog} />
                <Route exact path="/search" component={Search} />
                <Route exact path="/products">
                  <Redirect to="/catalog" />
                </Route>
                <Route path="/products/:id" component={Product} />
                <Route exact path="/partners" component={Partners} />
                <Route path="/partners/:id" component={Partner} />
                <Route path="/cart" component={Cart} />
                <Route path="/checkout" component={Checkout} />
                <Route exact path="/orders" component={Orders} />
                <Route path="/orders/:orderId" component={Order} />
                <Route path="/faq" component={Faq} />
                <Route path="/request-pricing/:id" component={RequestPricing} />
                <Route
                  path="/enterprise-pricing/:id"
                  component={RequestPricing}
                />
                <Route
                  exact
                  path="/request-pricing"
                  component={RequestPricing}
                />
                <Route exact path="/purchase-terms" component={PurchaseTerms} />
                <Route exact path="/cookie-policy" component={CookiePolicy} />
                <Route exact path="/contact-us" component={ContactUs} />
                <Route exact path="/error" component={ErrorPage} />
                <Route exact path="/" component={Home} />

                {/* Handle old store redirects */}
                <Route
                  exact
                  path="/product.aspx"
                  component={OldStoreRedirects}
                />
                <Route
                  exact
                  path="/category.aspx"
                  component={OldStoreRedirects}
                />
                <Route
                  exact
                  path="/search.aspx"
                  component={OldStoreRedirects}
                />
                <Route exact path="/default.aspx">
                  <Redirect to="/" />
                </Route>

                {/* Not Found intentionally last */}
                <Route path="*" component={NotFound} />
              </Switch>
            </Site>
          </CartProvider>
        </Auth>
      </ScrollToTop>
    </Router>
  );
};

export default App;
